import { Component, Input, OnDestroy } from '@angular/core';
import { ContainerEvents } from '../types';
import { UploadService } from '../../../service';
import { Subscription } from 'rxjs';
import {FileObject, FileObjectStatus} from '../../../model/analysis-details.model';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnDestroy {
  @Input() fileObject: FileObject;
  @Input() oddRow: boolean;
  FileObjectStatus = FileObjectStatus;
  containerEventSubscription: Subscription;
  constructor(private uploadService: UploadService) {
    this.containerEventSubscription = uploadService.uploadContrainerEvent$.subscribe(
        containerEvent => {
          this.handleContainerEvent(containerEvent)
          // console.log(containerEvent);
          
        }
    );
  }

  private handleContainerEvent(containerEvent: ContainerEvents) {
    if (containerEvent === ContainerEvents.Delete) {
      return this.clear();
    }
  }

  clear() {
    if (this.fileObject.status !== FileObjectStatus.Uploading) {
      this.fileObject.status = FileObjectStatus.Deleted;
      this.uploadService.publishFileUploadEvent(this.fileObject);
    }
  }

  ngOnDestroy() {
    this.containerEventSubscription.unsubscribe();
  }
}
